/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CreateInvitationRequest {
  principal?: string;
  invitation?: Invitation;
}

export interface CreateInviteRequest {
  resource?: SRN;
  /** @example "82fea4b2-42c2-4032-b45f-6e120a381150" */
  profileId: string;
  deliveryMethods?: DeliveryMethod[] | null;
  /**
   * If provided, limits the number of concurrent acceptances that may exist for the invitation
   * @example 1
   */
  limit?: number | null;
  /** Additional information for rendering the invitation template. */
  metadata?: Metadata;
  /** Optional expiration in seconds from epoc */
  expiration?: number | null;
}

export interface CreateInvitationResponse {
  /**
   * A unique identifier for the created invitation
   * @example "3a0a1b4d-51b9-4828-b9f2-cd773d63545b"
   */
  invitationId?: string;
  /**
   * The URL that can be used to accept the invitation
   * @example "https://www.example.com"
   */
  acceptUrl?: string;
}

export interface Invitation {
  /**
   * A unique identifier for the invitation
   * @example "3a0a1b4d-51b9-4828-b9f2-cd773d63545b"
   */
  id?: string;
  resource?: SRN;
  /**
   * Identifies the grant type, acceptance template, and acceptance redirect uri for the invitation
   * @example "a8399861-1e5f-421d-923a-e9d5cc915918"
   */
  profileId?: string;
  deliveryMethods?: DeliveryMethod[] | null;
  /**
   * Identifies the number of concurrent acceptances that are allowed for the invitation
   * @example 1
   */
  limit?: number | null;
  /** Additional information for rendering the invitation template. */
  metadata?: Metadata;
  /** Optional expiration in seconds from epoc */
  expiration?: number;
  /**
   * The URL that can be used to accept the invitation
   * @example "https://www.example.com"
   */
  acceptUrl?: string;
}

export interface DeliveryMethod {
  /**
   * Identifies the method of delivery specified by the delivery target.  One of: email, phonenumber, loginid
   * @example "email"
   */
  deliveryType?: string;
  /**
   * Where to send the invitation
   * @example "example@samsung.com"
   */
  deliveryTarget?: string;
}

export interface AcceptInvitationRequest {
  /** @example "st1:iam::user/04a21a65-9824-4033-8072-8c928ad65773" */
  principal?: string;
  /** @example "3a0a1b4d-51b9-4828-b9f2-cd773d63545b" */
  invitationId?: string;
}

export type DeviceId = string;

export interface SRN {
  root?: SRNRootId;
  components?: SRNComponentId[];
}

export interface SRNRootId {
  /**
   * One of: core, iam, platform, mdu, developer
   * @example "developer"
   */
  service?: string;
  /** @example "c38e1ab2-29c9-4ddb-9b99-b5212091ba4a" */
  id?: string;
}

export interface SRNComponentId {
  /**
   * One of: root, location, device, user, property, group, role, policy, unit, partner, installedapp, channel, deviceprofile, namespace, driver
   * @example "channel"
   */
  kind?: string;
  /** @example "78d5605c-af9f-483e-8c12-46d00a9fd532" */
  id?: string;
}

/**
 * Additional information for rendering the invitation template.
 * @example {"name":"Portal Gun Driver - VERY Beta","description":"Uh, this is a driver channel for the portal gun. It works... probably. If you end up trapped in some other dimension then it's your fault. Don't be looking for some other Rick to get you out of it.","owner":"Rick Sanchez","termsUrl":"https://en.wikipedia.org/wiki/Rick_Sanchez_(Rick_and_Morty)","EMAIL_ADDRESS_OF_INVITEE":"personEmail@theorganization.com","EMAIL_ADDRESS_OF_INVITOR":"personInviting","NAME_OF_ORGANIZATION":"theorganization"}
 */
export type Metadata = any;

/** Identifies a number of common invitation details */
export interface InvitationProfile {
  /**
   * A unique UUID identifier for this invitation profile
   * @example "f4c55fc7-96fc-4a8a-8901-8bc44df77653"
   */
  id?: string;
  prefix?: SRN;
  /** The grant type that is applied upon acceptance of the invitation */
  grantType?: GrantType;
  /**
   * The web/email template to use for acceptance of the invitation
   * @example "channel"
   */
  acceptTemplate?: string;
  /**
   * The URI to redirect to upon acceptance / if invitation is already accepted
   * @example "https://callawayd.smartthingsgdev.com/channels/<resource:id>"
   */
  redirectUri?: string;
  /**
   * Identifies whether the invitations based on this profile may be accepted by anyone
   * @example true
   */
  open?: boolean;
  /**
   * Limits the number of acceptances for invitations based on this profile
   * @example 100
   */
  acceptLimit?: number | null;
  /**
   * The number of invitations that have been created based on this invitation profile.  Not used when creating an invitation profile, and will be ignored if provided.
   * @example 1000
   */
  invitations?: number | null;
}

/**
 * The grant type that is applied upon acceptance of the invitation
 * @example "cast"
 */
export enum GrantType {
  Share = 'share',
  Restrictedshare = 'restrictedshare',
  Admin = 'admin',
  Cast = 'cast',
  Orgadmin = 'orgadmin',
  Orgdeveloper = 'orgdeveloper',
  Mfuadmin = 'mfuadmin',
  Mfuinstaller = 'mfuinstaller',
  Mfudelegatedinstaller = 'mfudelegatedinstaller',
  Mfutenant = 'mfutenant',
}

/** URLs related to the response.  For example: next page links for paged results */
export interface Links {
  /** @example "https://www.example.com" */
  page?: string | null;
}

/** A page of invitations */
export interface InviteResultPage {
  items?: Invitation[];
  /** URLs related to the response.  For example: next page links for paged results */
  links?: Links;
}

/** A page of schema invitations */
export interface SchemaInvitePage {
  items?: SchemaAppInvite[];
  /** URLs related to the response.  For example: next page links for paged results */
  links?: Links;
}

/** A page of invitation profiles */
export interface InviteProfileResultPage {
  items?: InvitationProfile[];
  /** URLs related to the response.  For example: next page links for paged results */
  links?: Links;
}

export interface Link {
  /**
   * An absolute URL linking to a resource.
   * @example "https://..."
   */
  href?: string;
}

/** A request to create a QR code location invitations */
export interface CreateLocationQRInviteRequest {
  /** The unique identifier for the location to share */
  locationId?: string;
  /** One or more instances of consent. */
  consent?: Consent[];
  /** Specify the accessLevel.  Default is `full`.  Allowed types are `full` and `restricted` */
  accessLevel?: string;
  /** Optional list of device UUIDs to be accessible to the invited user. If not provided, all devices will be accessible to the invited user. */
  deviceList?: DeviceId[];
  /** Optional time in epoch seconds in which the access granted by the invitation is revoked */
  accessExpiration?: string;
}

/** A response to a create QR code location invitation request */
export interface CreateLocationQRInviteResponse {
  /** The unique identifier for the created invitation */
  invitationId?: string;
  /** A long-form unique identifier for the invitation that should be used to generate the QR code image */
  longCode?: string;
}

/** A request to accept QR code location invitation */
export interface AcceptLocationQRInviteRequest {
  /** One or more instances of consent. */
  consent?: Consent[];
}

/** A response to an accept QR code location invitation request */
export interface AcceptLocationQRInviteResponse {
  /** The unique identifier for the location */
  locationId?: string;
  /** The user defined name for the location */
  locationName?: string;
}

/** A request to create a schema app invitation */
export interface CreateSchemaAppInviteRequest {
  /** The unique Id of the schema app */
  schemaAppId?: string;
  /** An optional description field that can be used to add a description to the invitation */
  description?: string;
}

/** A response to a create Schema App invitation request */
export interface CreateSchemaAppInviteResponse {
  /** The unique identifier for the created invitation */
  invitationId?: string;
}

/** A schema app invitation */
export interface SchemaAppInvite {
  /** The unique Id of the invitation */
  id?: string;
  /** The unique Id of the schema app */
  schemaAppId?: string;
  /** Optional description attached to the invitation */
  description?: string;
  /** Optional expiration in seconds from epoc */
  expiration?: number | null;
  /**
   * The URL that can be used to accept the invitation
   * @example "https://www.example.com"
   */
  acceptUrl?: string;
  /**
   * The URL that can be used to accept the invitation
   * @example "https://www.example.com"
   */
  declineUrl?: string;
  /** The short code referencing the invitation */
  shortCode?: string;
}

/** Acceptance status of a schema invitation */
export interface CheckSchemaAppInviteAcceptanceResponse {
  /** The unique Id of the schema app */
  schemaAppId?: string;
  /** A boolean to represent if the invitation has been accepted or not */
  isAccepted?: boolean;
  /** Optional description attached to the invitation */
  description?: string;
  /** Optional expiration in seconds from epoc */
  expiration?: number | null;
  /**
   * The URL that can be used to accept the invitation
   * @example "https://www.example.com"
   */
  acceptUrl?: string;
  /**
   * The URL that can be used to accept the invitation
   * @example "https://www.example.com"
   */
  declineUrl?: string;
  /** The short code referencing the invitation */
  shortCode?: string;
}

/** Response from Accept schema app request */
export interface AcceptSchemaAppInviteResponse {
  /** The unique Id of the schema app */
  schemaAppId?: string;
}

/** Contains information about consent */
export interface Consent {
  /**
   * The locksmith key for the consent record
   * @example "pp_location"
   */
  key?: string;
  /** The 'data' element of the consent record stored in locksmith.  Contains details on the consent. */
  data?: ConsentData;
}

/** The 'data' element of the consent record stored in locksmith.  Contains details on the consent. */
export interface ConsentData {
  agreed?: ConsentAgreed[];
}

/** Contains detail on a specific instance of consent */
export interface ConsentAgreed {
  /**
   * Two character ISO country code of the consenting user
   * @example "kr"
   */
  country?: string;
  /**
   * ISO-8601 date time of the consent
   * @example "2020-06-16T20:50:49+09:00"
   */
  updatetime?: string;
  /**
   * The version of the document that was consented
   * @example "1.0.0"
   */
  version?: string;
  /**
   * Identifies whether agreement is optional
   * @example false
   */
  isOptional?: boolean;
  /**
   * Identifies whether user agreed/consented
   * @example true
   */
  isAgreed?: boolean;
}

/** A response indicating an error occured, with details about the error */
export interface ErrorResponse {
  /**
   * A unique id for the request
   * @example "17667c69-36c9-4cd5-a07b-f9d8977a04bf"
   */
  requestId?: string;
  /** Contains information about an error */
  error?: Error;
}

/** Contains information about an error */
export interface Error {
  /**
   * An error code
   * @example "400"
   */
  code?: string;
  /**
   * A description of the error
   * @example "MEMBER_LIMIT_REACHED"
   */
  message?: string;
  /** @example [] */
  details?: Error[];
}

/** Represents a single page of Invitations available in a user account. */
export interface PagedInvitations {
  items: EmailInvitation[];
  /** URLs related to the response.  For example: next page links for paged results */
  _links?: Links;
}

/** @example {"invitationId":"0dc4abe0-583c-494f-b45c-e4d9776fc1e5","inviterUsername":"user_uuid:76275c80-21e2-68bb-1ea2-f8b965a38932","entityType":"LOCATION","entityId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","deliveryMethods":[{"deliveryType":"EMAIL","deliveryTarget":"example@example.com"}],"status":"PENDING","expiration":"2018-02-14T12:44:18+00:00"} */
export interface EmailInvitation {
  /**
   * The ID of the invitation.
   * @format uuid
   */
  invitationId: string;
  /** The username for the inviter. */
  inviterUsername: string;
  /** The entity type you are inviting access to. */
  entityType: EntityTypes;
  /** The identifier for the specific entity you are inviting access to. */
  entityId: string;
  deliveryMethods: DeliveryMethods;
  /** The current status of the invite. */
  status: StatusTypes;
  /**
   * The IS0-8601 date time string in UTC for the expiration of an invitation.
   * @example "2018-02-14T12:44:18+00:00"
   */
  expiration: string;
}

/** The entity type you are inviting access to. */
export enum EntityTypes {
  LOCATION = 'LOCATION',
}

export interface ConsentPayload {
  agreed: ConsentPayloadAgreed[];
}

export interface ConsentPayloadAgreed {
  country: string;
  /** ISO 8601 date-time */
  updatetime: string;
  version: string;
  isOptional: boolean;
  isAgreed: boolean;
}

export type DeliveryMethods = Delivery[];

/**
 * List of device UUIDs to be accessible to the invited user.
 * If not provided, all devices will be accessible to the invited user.
 */
export type DeviceList = string[];

export interface Delivery {
  /** The delivery type of the invite. */
  deliveryType?: DeliveryType;
  /** Target for the delivery type. */
  deliveryTarget?: string;
}

/** The delivery type of the invite. */
export enum DeliveryType {
  EMAIL = 'EMAIL',
  LOGINID = 'LOGINID',
}

/** The current status of the invite. */
export enum StatusTypes {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
}

/** @example {"entityType":"LOCATION","permissionExpiration":"2023-08-15T00:00:00Z","entityId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","deviceList":["E8DF13FC-318C-42B4-9AA9-B07ADFFE5874","894F1489-EBE9-4C4F-9205-042E74E98D7A"],"deliveryMethods":[{"deliveryType":"EMAIL","deliveryTarget":"example@example.com"}]} */
export interface CreateEmailInvitationRequest {
  /**
   * An ISO 8601 date-time indicating the expiration of permissions for the user.
   * This date must not be more than one year in the future.
   * If not provided, the invited user's permissions will not expire.
   * @format date-time
   */
  permissionExpiration?: string;
  /**
   * List of device UUIDs to be accessible to the invited user.
   * If not provided, all devices will be accessible to the invited user.
   */
  deviceList?: DeviceList;
  /** The entity type you are inviting access to. */
  entityType: EntityTypes;
  /** The identifier for the specific entity you are inviting access to. */
  entityId: string;
  deliveryMethods: DeliveryMethods;
  consent?: ConsentPayload;
  /**
   * Can be set to `restrictedshare` to grant limited permissions to the invitee, or `share` to grant full access.
   * Defaults to `share` if no value is passed in.
   */
  grantType?: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type DeleteInvitationResponse = object;

/**
 * An empty object response.
 * @example {}
 */
export type AcceptInvitationResponse = object;

/**
 * An empty object response.
 * @example {}
 */
export type RejectInvitationResponse = object;

export interface ListInvitesParams {
  /**
   * The resource SRN of the invitations to retrieve.
   * @example "st1:developer::channel/4d6fed62-1a30-46be-9b87-be7e3bb55d76"
   */
  resource: string;
  /**
   * The maximum number of records to return in a single page. Acceptable values: 1-100 (Default = 100)
   * @example 10
   */
  limit?: number;
  /**
   * The page key, used when retreiving the next page of results
   * @example "ewogICJTb3J0SWQiIDogewogICAgInMiIDogImkvYTgzOTk4NjEtMWU1Zi00MjFkLTkyM2EtZTlkNWNjOTE1OTE4LzI2YmNiNGRmLWI3ZDQtNDUwYi1hMDNjLTZiNTA3ZTRlNWI1NyIKICB9LAogICJQYXJ0aXRpb25JZCIgOiB7CiAgICAicyIgOiAic3QxOjU6OjEyL2JhY2RiMzQ1LTYzN2MtNGVmNC1hN2U4LWEwNWQ0YzVkZWE2YSIKICB9Cn0="
   */
  page?: string;
}

export interface ListSchemaAppInvitationsParams {
  /**
   * The schema app ID you would like a list of invitations for.
   * @example "bd7c772f-9b56-48b3-8f96-7b84787060ec"
   */
  schemaAppId: string;
  /**
   * The maximum number of records to return in a single page. Acceptable values: 1-100 (Default = 100)
   * @example 10
   */
  limit?: number;
  /**
   * The page key, used when retreiving the next page of results
   * @example "ewogICJTb3J0SWQiIDogewogICAgInMiIDogImkvYTgzOTk4NjEtMWU1Zi00MjFkLTkyM2EtZTlkNWNjOTE1OTE4LzI2YmNiNGRmLWI3ZDQtNDUwYi1hMDNjLTZiNTA3ZTRlNWI1NyIKICB9LAogICJQYXJ0aXRpb25JZCIgOiB7CiAgICAicyIgOiAic3QxOjU6OjEyL2JhY2RiMzQ1LTYzN2MtNGVmNC1hN2U4LWEwNWQ0YzVkZWE2YSIKICB9Cn0="
   */
  page?: string;
}

export interface SchemaAppCheckAcceptanceParams {
  /**
   * The invitationId you would like to see the acceptance status of.
   * @example "bd7c772f-9b56-48b3-8f96-7b84787060ec"
   */
  invitationId: string;
}

export interface ListInviteProfilesParams {
  /**
   * The grant type for the invitation profiles
   * @example "cast"
   */
  grantType: string;
  /**
   * Optional full or partial prefix
   * @example "st1:developer::channel/"
   */
  prefix?: string;
  /**
   * The maximum number of records to return in a single page. Acceptable values: 1-100 (Default = 100)
   * @example 10
   */
  limit?: number;
  /**
   * The page key, used when retreiving the next page of results
   * @example "ewogICJTb3J0SWQiIDogewogICAgInMiIDogImkvYTgzOTk4NjEtMWU1Zi00MjFkLTkyM2EtZTlkNWNjOTE1OTE4LzI2YmNiNGRmLWI3ZDQtNDUwYi1hMDNjLTZiNTA3ZTRlNWI1NyIKICB9LAogICJQYXJ0aXRpb25JZCIgOiB7CiAgICAicyIgOiAic3QxOjU6OjEyL2JhY2RiMzQ1LTYzN2MtNGVmNC1hN2U4LWEwNWQ0YzVkZWE2YSIKICB9Cn0="
   */
  page?: string;
}

export interface ListInvitationsInviteeParams {
  /** Filter by invitation status. Default is PENDING. */
  status?: string;
}

export interface ListInvitationsInviterParams {
  /** Filter by invitation status. Default is PENDING. */
  status?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'https://bestow-regionald.smartthingsgdev.com';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Bestow
 * @version 0.1.0
 * @baseUrl https://bestow-regionald.smartthingsgdev.com
 * @contact Allan Holmstadt <allan.holmstadt@smartthings.com>
 *
 * Create and send invitations that, on acceptance, apply user grants on the specified resource. You can learn more about Bestow at
 * [https://github.ecodesamsung.com](https://github.ecodesamsung.com/iot/bestow)
 */
export class BestowApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  invites = {
    /**
     * No description
     *
     * @tags invites
     * @name CreateInvite
     * @summary Create an invitation.
     * @request POST:/invites
     * @secure
     */
    createInvite: (data: CreateInviteRequest, params: RequestParams = {}) =>
      this.request<CreateInvitationResponse, void>({
        path: `/invites`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags invites
     * @name ListInvites
     * @summary List existing invitations
     * @request GET:/invites
     * @secure
     */
    listInvites: (query: ListInvitesParams, params: RequestParams = {}) =>
      this.request<InviteResultPage, void>({
        path: `/invites`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags invites
     * @name GetInvite
     * @summary Retrieve an existing invitation
     * @request GET:/invites/{id}
     * @secure
     */
    getInvite: (id: string, params: RequestParams = {}) =>
      this.request<Invitation, void>({
        path: `/invites/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags invites
     * @name DeleteInvite
     * @summary Revoke an existing invitation
     * @request DELETE:/invites/{id}
     * @secure
     */
    deleteInvite: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/invites/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags invites
     * @name AcceptInvite
     * @summary Accept an invitation
     * @request PUT:/invites/{id}/accept
     * @secure
     */
    acceptInvite: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/invites/${id}/accept`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags qrInvites
     * @name CreateLocationQrInvite
     * @summary Create a QR code location invitation
     * @request POST:/invites/locationQR
     * @secure
     */
    createLocationQrInvite: (data: CreateLocationQRInviteRequest, params: RequestParams = {}) =>
      this.request<CreateLocationQRInviteResponse, ErrorResponse | void>({
        path: `/invites/locationQR`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags qrInvites
     * @name AcceptQrInvite
     * @summary Accept a QR code location invitation
     * @request PUT:/invites/locationQR/{longCode}/accept
     * @secure
     */
    acceptQrInvite: (longCode: string, data: AcceptLocationQRInviteRequest, params: RequestParams = {}) =>
      this.request<AcceptLocationQRInviteResponse, ErrorResponse | void>({
        path: `/invites/locationQR/${longCode}/accept`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags schemaApp
     * @name CreateSchemaAppInvite
     * @summary Create an invitation for a schema app.
     * @request POST:/invites/schemaApp
     * @secure
     */
    createSchemaAppInvite: (data: CreateSchemaAppInviteRequest, params: RequestParams = {}) =>
      this.request<CreateSchemaAppInviteResponse, ErrorResponse | void>({
        path: `/invites/schemaApp`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags schemaApp
     * @name ListSchemaAppInvitations
     * @summary Get a list of invitations for a schema app.
     * @request GET:/invites/schemaApp
     * @secure
     */
    listSchemaAppInvitations: (query: ListSchemaAppInvitationsParams, params: RequestParams = {}) =>
      this.request<SchemaInvitePage, void>({
        path: `/invites/schemaApp`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags schemaApp
     * @name DeleteSchemaAppInvite
     * @summary Revoke an existing invitation
     * @request DELETE:/invites/schemaApp/{id}
     * @secure
     */
    deleteSchemaAppInvite: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/invites/schemaApp/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags schemaApp
     * @name SchemaAppCheckAcceptance
     * @summary Checks the acceptance status of a specific schema app invitation.
     * @request GET:/invites/schemaApp/checkAcceptance
     * @secure
     */
    schemaAppCheckAcceptance: (query: SchemaAppCheckAcceptanceParams, params: RequestParams = {}) =>
      this.request<CheckSchemaAppInviteAcceptanceResponse, void>({
        path: `/invites/schemaApp/checkAcceptance`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags schemaApp
     * @name AcceptSchemaAppInvite
     * @summary Accept a schema app invitation
     * @request PUT:/invites/schemaApp/{ShortCode}/accept
     * @secure
     */
    acceptSchemaAppInvite: (shortCode: string, params: RequestParams = {}) =>
      this.request<AcceptSchemaAppInviteResponse, ErrorResponse | void>({
        path: `/invites/schemaApp/${shortCode}/accept`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  inviteProfiles = {
    /**
     * No description
     *
     * @tags inviteProfiles
     * @name CreateInviteProfile
     * @summary Create an invitation profile.
     * @request POST:/inviteProfiles
     * @secure
     */
    createInviteProfile: (data: InvitationProfile, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/inviteProfiles`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inviteProfiles
     * @name ListInviteProfiles
     * @summary List existing invitation profiles
     * @request GET:/inviteProfiles
     * @secure
     */
    listInviteProfiles: (query: ListInviteProfilesParams, params: RequestParams = {}) =>
      this.request<InviteProfileResultPage, void>({
        path: `/inviteProfiles`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags inviteProfiles
     * @name GetInviteProfile
     * @summary Retrieve an existing invitation profile by id
     * @request GET:/inviteProfiles/{id}
     * @secure
     */
    getInviteProfile: (id: string, params: RequestParams = {}) =>
      this.request<InvitationProfile, void>({
        path: `/inviteProfiles/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags inviteProfiles
     * @name DeleteInviteProfile
     * @summary Delete an invitation profile
     * @request DELETE:/inviteProfiles/{id}
     * @secure
     */
    deleteInviteProfile: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/inviteProfiles/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  invitations = {
    /**
     * @description Create Invitations for a single, specified user.  While the request payload suggests that multiple invitees are accepted, they are not.
     *
     * @tags Invitations
     * @name CreateInvitation
     * @summary Create a Invitation.
     * @request POST:/invitations
     * @secure
     */
    createInvitation: (data: CreateEmailInvitationRequest, params: RequestParams = {}) =>
      this.request<EmailInvitation, ErrorResponse>({
        path: `/invitations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all Invitations received by the current user.
     *
     * @tags Invitations
     * @name ListInvitationsInvitee
     * @summary List Invitations for an Invitee.
     * @request GET:/invitations/invitee
     * @secure
     */
    listInvitationsInvitee: (query: ListInvitationsInviteeParams, params: RequestParams = {}) =>
      this.request<PagedInvitations, ErrorResponse>({
        path: `/invitations/invitee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all Invitations sent by the current user.
     *
     * @tags Invitations
     * @name ListInvitationsInviter
     * @summary List Invitations for an Inviter.
     * @request GET:/invitations/inviter
     * @secure
     */
    listInvitationsInviter: (query: ListInvitationsInviterParams, params: RequestParams = {}) =>
      this.request<PagedInvitations, ErrorResponse>({
        path: `/invitations/inviter`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a specific Invitation.
     *
     * @tags Invitations
     * @name GetInvitation
     * @summary Get a Invitation.
     * @request GET:/invitations/{invitationId}
     * @secure
     */
    getInvitation: (invitationId: string, params: RequestParams = {}) =>
      this.request<EmailInvitation, ErrorResponse>({
        path: `/invitations/${invitationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Invitation.
     *
     * @tags Invitations
     * @name DeleteInvitation
     * @summary Delete a Invitation.
     * @request DELETE:/invitations/{invitationId}
     * @secure
     */
    deleteInvitation: (invitationId: string, params: RequestParams = {}) =>
      this.request<DeleteInvitationResponse, ErrorResponse>({
        path: `/invitations/${invitationId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Accept a specific Invitation.
     *
     * @tags Invitations
     * @name AcceptInvitation
     * @summary Accept a Invitation.
     * @request POST:/invitations/{invitationId}/accept
     * @secure
     */
    acceptInvitation: (invitationId: string, data: AcceptInvitationRequest, params: RequestParams = {}) =>
      this.request<AcceptInvitationResponse, ErrorResponse>({
        path: `/invitations/${invitationId}/accept`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reject a specific Invitation.
     *
     * @tags Invitations
     * @name RejectInvitation
     * @summary Rejects a Invitation.
     * @request DELETE:/invitations/{invitationId}/reject
     * @secure
     */
    rejectInvitation: (invitationId: string, params: RequestParams = {}) =>
      this.request<RejectInvitationResponse, ErrorResponse>({
        path: `/invitations/${invitationId}/reject`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
